// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31SW1","newExpiryDate":"styles_newExpiryDate__tlRTs","footer":"styles_footer__u0UTi"};